import WOW from 'wow.js';
import {initMainHeader} from '../js/src/header-init';
import {loadCSS, replaceGMapLink, Utils} from "../js/src/utils";
import {closeEventModal, openGuestModal} from "../js/pages/event-modal-from";
import '../scss/pages/tech-summit-3.scss';


initMainHeader();
replaceGMapLink();

if (window.innerWidth > Utils.screen.sm) {
    loadCSS('build/assets/css/animate.min.css');
    setTimeout(() => (new WOW({offset: 100, live: false, mobile: false})).init(), 200);
}

global.closeModal = closeEventModal;
global.openModal = openGuestModal;
// global.openSponsorModal = openSponsorModal;
global.scrollToSponsor = () => {
    const sponsorSection = document.querySelector('#request-sponsor-brochure');

    if (sponsorSection) {
        sponsorSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}

/**
 * initScrollEvent
 */
const initScrollEvent = () => {
    window.addEventListener('scroll', onScroll, {passive: true});
};

const diff = 100;
const hideTopPosition = 500;
let lastPos = 0;
let ticking = false;

const onScroll = () => {
     if (!ticking) {
        window.requestAnimationFrame(() => {
            const currPos = window.scrollY || document.documentElement.scrollTop;
            const cl = document.body.classList;

            ticking = false;
            if (currPos < hideTopPosition) {
                cl.remove('down');
                return
            }

            if (currPos > lastPos + diff) {
                cl.add('down');
                lastPos = currPos;
            } else if (currPos < lastPos - diff) {
                cl.remove('down');
                lastPos = currPos;
            }
        });
        ticking = true;
    }
}

window.addEventListener('resize', initScrollEvent);
initScrollEvent();
